'use client';

import React from 'react';

export interface MoneyProps {
  /** Numeric amount (formatted he-IL) or a pre-formatted string. */
  amount: number | string;
  /** Currency glyph, leads the digits. Default ₪. */
  currency?: string;
  strike?: boolean;
  muted?: boolean;
  style?: React.CSSProperties;
}

export interface ClockProps {
  value: string;
  style?: React.CSSProperties;
}

/** Money — ₪ leads the digits, fully bidi-isolated, tabular. <Money amount={240}/> → ₪240 */
export function Money({
  amount,
  currency = '₪',
  strike = false,
  muted = false,
  style = {},
}: MoneyProps) {
  return (
    <bdi
      style={{
        fontVariantNumeric: 'tabular-nums lining-nums',
        fontFamily: 'var(--font-sans)',
        whiteSpace: 'nowrap',
        textDecoration: strike ? 'line-through' : 'none',
        color: muted ? 'var(--text-tertiary)' : 'inherit',
        unicodeBidi: 'isolate',
        ...style,
      }}
    >
      {currency}
      {typeof amount === 'number' ? amount.toLocaleString('he-IL') : amount}
    </bdi>
  );
}

/** Time that never mirrors/reverses digits under RTL. <Clock value="14:30"/> */
export function Clock({ value, style = {} }: ClockProps) {
  return (
    <bdi
      style={{
        fontVariantNumeric: 'tabular-nums lining-nums',
        unicodeBidi: 'isolate',
        direction: 'ltr',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {value}
    </bdi>
  );
}
